import {createSlice} from '@reduxjs/toolkit';
import {NotificationManager} from '../components/common/react-notifications';
import {defaultLocale, messageDismissTime} from '../constants/defaultValues';
import {
  checkBannerDismissed, getCurrentLanguage, resetBanner, setBannerDismissed, setCurrentLanguage,
} from '../helpers/Utils';
import {api} from './api';
import {resetSlicesToInitialState} from './userSlice';

const initialState = {
  bannerDismissed: checkBannerDismissed(),
  // This lets a user set change the app language and be able to leave
  // the app and return to that language, as long as they don't log out
  locale: getCurrentLanguage(),
  unprotectedLogo: null,
};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    changeLocale: (state, {payload}) => {
      setCurrentLanguage(payload);
      NotificationManager.success(
        'Language changed',
        'Success',
        messageDismissTime,
      );
      state.locale = payload;
    },
    setUnprotectedLogo: (state, {payload}) => {
      state.unprotectedLogo = payload;
    },
    dismissBanner: state => {
      setBannerDismissed();
      state.bannerDismissed = true;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetSlicesToInitialState, () => {
      // Upon logout, we reset back to english
      setCurrentLanguage(defaultLocale);
      resetBanner();
      // the initialState.locale above may or may not be english,
      // so create new initial state manually
      return {
        bannerDismissed: false,
        locale: defaultLocale,
        unprotectedLogo: null,
      };
    });
    builder.addMatcher(api.endpoints.login.matchFulfilled, state => {
      state.unprotectedLogo = null;
    });
  },
});

export const {changeLocale, dismissBanner, setUnprotectedLogo} = slice.actions;

export default slice.reducer;
